export default __webpack_public_path__ + "static/VisibleTrackThumbnail-f689e4cc5c94925a75e5dfa41e49fbf1.jpg";